import { Stack} from "@mui/material";
import Layout from "./components/Layout";
import Categories from "./components/Categories";
import Chat from "../Tools/Chat";
import Status from "./components/Status";
import Products from "./components/Products";
import DpcSessions from "./components/DpcSessions";
import UserContext from "../../services/Context/UserContext";
import Confirm from "./components/Confirm";
import useCart from "./utils/useCart";
import { useContext, useEffect } from "react";
import useCourse from "./utils/useCourse";
import Loader from "../Tools/Loader";
import { useSearchParams } from "react-router-dom";
import LearnyDaysAlert from "./components/LearnyDaysAlert";


export default function Funding(){

    const { user } = useContext(UserContext)

    const course = useCourse()

    const { setCart, resetCart } = useCart()

    useEffect(() => {

        resetCart()

        if(user){

            setCart({ category: user.category.id, status: user.status.id })

        }else if(course){

            setCart({ category: course.category.id })
        }

    }, [user, course, setCart, resetCart])

    const [urlParams] = useSearchParams();
    const nextCourseId = urlParams.get('next') ?? null;

    useEffect(() => {
        if (nextCourseId) {
            window.localStorage.setItem('nextCourseId', nextCourseId);
        }
    }, [nextCourseId]);

    return (
        <Layout>

            <Stack spacing={3} alignItems="center">
                        
                {!user && <>

                    <Categories />

                    <Status />

                </>}

                {course ? 
                    <>
                        <LearnyDaysAlert />

                        <Products />

                        <DpcSessions />

                        <Confirm />

                    </>
                    :
                    <Loader />    
                }


            </Stack>

            <Chat />

        </Layout>
    );
}